var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "documents" },
    [
      _c("m-create-analyse", {
        attrs: { active: _vm.shouldDisplayModal, "modal-info": _vm.modalInfo },
        on: {
          close: _vm.closeModalCreateDocument,
          submitted: _vm.updateAllData,
        },
      }),
      _vm.isLoadingArchive
        ? _c("c-loader", {
            attrs: {
              active: _vm.isLoadingArchive,
              label: "Загружаем архив с документами",
              height: "fixed",
            },
          })
        : _vm._e(),
      _c("transition", { attrs: { name: "fade" } }, [
        !_vm.isDataLoading && !_vm.noRequiredAnalyses
          ? _c(
              "div",
              {
                staticClass: "documents-need-add",
                class: {
                  "documents-need-add-hide": _vm.shouldHideNeededDocuments,
                },
              },
              [
                _c("div", { staticClass: "documents-need-add-title" }, [
                  _vm.requiredAnalysesToAdd.length > 0
                    ? _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle",
                              value: "documents-need-add-docs-group-collapse",
                              expression:
                                "'documents-need-add-docs-group-collapse'",
                            },
                          ],
                          staticClass: "documents-need-add-title-button",
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "8",
                                height: "5",
                                viewBox: "0 0 8 5",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M3.53976 4.4727C3.28126 4.21408 3.28126 3.79476 3.53976 3.53614L6.87001 0.204315C7.12851 -0.0543084 7.54762 -0.054308 7.80612 0.204315C8.06462 0.462938 8.06462 0.88225 7.80612 1.14087L4.47587 4.4727C4.21737 4.73132 3.79826 4.73132 3.53976 4.4727Z",
                                  fill: "#0066FF",
                                },
                              }),
                              _c("path", {
                                attrs: {
                                  d: "M4.47058 4.4727C4.72908 4.21408 4.72908 3.79476 4.47058 3.53614L1.12999 0.193967C0.871489 -0.064656 0.452377 -0.0646556 0.193876 0.193968C-0.0646252 0.452591 -0.0646252 0.871902 0.193876 1.13053L3.53447 4.4727C3.79297 4.73132 4.21208 4.73132 4.47058 4.4727Z",
                                  fill: "#0066FF",
                                },
                              }),
                            ]
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" Необходимо добавить "),
                ]),
                _c(
                  "b-collapse",
                  {
                    attrs: {
                      id: "documents-need-add-docs-group-collapse",
                      visible: "",
                    },
                  },
                  [
                    _vm.requiredAnalysesToAdd.length > 0
                      ? _vm._l(_vm.requiredAnalysesToAdd, function (group) {
                          return _c(
                            "div",
                            {
                              key: group.name,
                              staticClass: "documents-need-add-docs-group",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "documents-need-add-docs-group-title",
                                },
                                [_vm._v(_vm._s(group.name))]
                              ),
                              _vm._l(group.items, function (analyse) {
                                return _c(
                                  "div",
                                  {
                                    key: analyse.id,
                                    staticClass:
                                      "documents-need-add-docs-group-item",
                                  },
                                  [
                                    _c("c-button", {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.isUserAbleToControlAnalyses,
                                          expression:
                                            "isUserAbleToControlAnalyses",
                                        },
                                        {
                                          name: "b-popover",
                                          rawName: "v-b-popover.html",
                                          value: {
                                            container: "#app",
                                            trigger: "hover blur",
                                            content: "Добавить анализ",
                                            placement: "top",
                                          },
                                          expression:
                                            "{\n                  container: '#app',\n                  trigger: 'hover blur',\n                  content: 'Добавить анализ',\n                  placement: 'top',\n                }",
                                          modifiers: { html: true },
                                        },
                                      ],
                                      staticClass:
                                        "documents-need-add-docs-group-item-add",
                                      attrs: {
                                        size: "small",
                                        icon: {
                                          icon: "plus",
                                          color: "primary",
                                        },
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openModalCreateAnalyse(
                                            analyse.id
                                          )
                                        },
                                      },
                                    }),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "documents-need-add-docs-group-item-name",
                                        attrs: { title: analyse.name },
                                      },
                                      [_vm._v(_vm._s(analyse.name))]
                                    ),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          )
                        })
                      : _vm._e(),
                    _c("all-documents-added-success-message", {
                      attrs: {
                        "should-display": _vm.displayAllAnalysesAddedMessage,
                        message: "Все обязательные анализы добавлены",
                      },
                      on: {
                        "close-action": function ($event) {
                          _vm.shouldHideRequiredToAddBlock = false
                        },
                      },
                    }),
                  ],
                  2
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      !_vm.isDataLoading
        ? _c(
            "div",
            {
              staticClass: "documents-content",
              class: {
                "documents-content-not-need-documents-add":
                  _vm.shouldExpandTable,
              },
            },
            [
              _c("div", { staticClass: "documents-content-header" }, [
                _c(
                  "div",
                  {
                    staticClass: "documents-content-header-buttons",
                    class: { "no-required-analyses": _vm.noRequiredAnalyses },
                  },
                  [
                    !_vm.isTableLoading && _vm.noRequiredAnalyses
                      ? _c(
                          "div",
                          { staticClass: "no-required-analyses-label" },
                          [
                            _vm._v(" Для должности "),
                            _c("span", [_vm._v(_vm._s(_vm.userPosition))]),
                            _vm._v(" нет обязательных анализов "),
                          ]
                        )
                      : _vm._e(),
                    !_vm.noRequiredAnalyses
                      ? _c("c-button", {
                          staticClass:
                            "documents-content-header-buttons-download",
                          attrs: {
                            size: "small",
                            responsive: true,
                            disabled: !_vm.isAbleToDownloadZip,
                            icon: "download",
                            type: "with-icon",
                            label: "Скачать одним архивом",
                          },
                          on: { click: _vm.downloadAnalysesZip },
                        })
                      : _vm._e(),
                    _vm.isUserAbleToControlAnalyses
                      ? _c("c-button", {
                          staticClass:
                            "documents-content-header-buttons-add-document",
                          class: {
                            "no-required-analyses-add-button":
                              _vm.noRequiredAnalyses,
                          },
                          attrs: {
                            size: "small",
                            responsive: !_vm.noRequiredAnalyses,
                            icon: { icon: "plus", color: "primary" },
                            type: "with-icon",
                            label: "Добавить анализ",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.openModalCreateAnalyse(null)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c(
                "div",
                { staticClass: "documents-content-table" },
                [
                  !_vm.isTableLoading &&
                  !_vm.isDataLoading &&
                  !_vm.noRequiredAnalyses
                    ? _c("medical-documents-table", {
                        ref: "table",
                        staticClass: "documents-content-table-table",
                        attrs: {
                          id: "actingDocuments",
                          levels: 1,
                          "sorted-column": _vm.sortedColumn,
                          "disabled-columns": [],
                          data: _vm.tableDataMedicalDocuments,
                          "empty-records-label": "Анализы пока не добавлены",
                        },
                        on: {
                          sortedEvent: _vm.resortTable,
                          resendAnalyse: _vm.resendAnalyse,
                          analyseDeleted: _vm.onAnalyseDelete,
                        },
                      })
                    : _vm._e(),
                  _vm.isTableLoading
                    ? _c("c-loader", {
                        staticClass: "documents-content-table-loader",
                        attrs: {
                          label: "Данные загружаются",
                          active: _vm.isTableLoading,
                          height: "280",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.isDataLoading
        ? _c("c-loader", {
            staticClass: "documents-loader",
            attrs: {
              label: "Данные загружаются",
              active: _vm.isDataLoading,
              height: "500",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }